import axios from '../axios'
// 登录
export const login = data => {
  return axios({
    url: '/api/sys/login',
    method: 'post',
    data
  })
}
// 注销
export const out = data => {
  return axios({
    url: '/api/sys/logout',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/moudules/login.js